import { Component } from '@angular/core';
import { BuildInfoService } from './build-info.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'abc-setup-info',
  template: `
    <div class="build-version" id="build-version" aria-label="Build version">
     {{ version | async }}
    </div>
  `,
  styles: [`
    .build-version {
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 2px 6px;
      font-size: 11px;
      line-height: 16px;
      color: var(--title-color, #696767ff);
      /*background-color: rgba(0, 0, 0, 0.05);*/
      border-radius: 4px;
      z-index: 1000;
    }
  `],
  standalone: true,
  imports: [AsyncPipe],
})
export class SetupInfoComponent {

public version = this.buildInfo.getFullVersion();
  constructor(private buildInfo: BuildInfoService) {}
}